import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	priortiyInOpsgenieNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.priortiy-in-opsgenie-non-final',
		defaultMessage: 'Priority in Opsgenie',
		description: 'Transition home incidents step table priority in Opsgenie head',
	},
	priortiyInJiraNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.priortiy-in-jira-non-final',
		defaultMessage: 'Priority in Jira',
		description: 'Transition home incidents step table priority in Jira head',
	},
	highestPriorityNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.highest-priority-non-final',
		defaultMessage: 'Highest',
		description: 'Transition home incidents step priority table highest priority',
	},
	highPriorityNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.high-priority-non-final',
		defaultMessage: 'High',
		description: 'Transition home incidents step priority table high priority',
	},
	mediumPriorityNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.medium-priority-non-final',
		defaultMessage: 'Medium',
		description: 'Transition home incidents step priority table medium priority',
	},
	lowPriorityNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.low-priority-non-final',
		defaultMessage: 'Low',
		description: 'Transition home incidents step priority table low priority',
	},

	lowestPriorityNonFinal: {
		id: 'eoc-changeboarding.transition-home.incidents-step.priority-table.lowest-priority-non-final',
		defaultMessage: 'Lowest',
		description: 'Transition home incidents step priority table lowest priority',
	},
});
